<template>
  <div
    class="event-date-card"
    :class="{ today: isToday }">
    <div class="event-date-card__inner">
      <div
        class="event-date-card__date"
        :class="{ '--holiday': isHoliday, '--sunday': isSunday, '--saturday': isSaturday }">
        {{ dateNum }}&nbsp;({{ weekDay | weekDay2Kanji }})
      </div>
      <div v-if="isManager">
        <button
          class="event__add-btn btn--circle"
          @click="goToAddEvent">
          <span class="event__add-icon material-icons text-blue">
            add
          </span>
        </button>
      </div>
    </div>
    <slot />
  </div>
</template>

<script>
import getDay from 'date-fns/getDay'
import getDate from 'date-fns/getDate'
import isToday from 'date-fns/isToday'
import format from 'date-fns/format'
import { isHoliday } from '@/utils/holidays'
export default {
  filters: {
    weekDay2Kanji (v) {
      switch (v) {
      case 0:
        return '日'
      case 1:
        return '月'
      case 2:
        return '火'
      case 3:
        return '水'
      case 4:
        return '木'
      case 5:
        return '金'
      case 6:
        return '土'
      default:
        console.error('out of weekdays')
        return null
      }
    }
  },
  props: {
    date: {
      type: Date,
      required: true
    },
    isManager: {
      type: Boolean,
      required: true
    }
  },
  computed: {
    isToday() {
      return isToday(this.date)
    },
    dateNum() {
      return getDate(this.date)
    },
    weekDay() {
      return getDay(this.date)
    },
    isSaturday() {
      return this.weekDay === 6
    },
    isSunday() {
      return this.weekDay === 0
    },
    isHoliday() {
      return isHoliday(this.date)
    }
  },
  methods: {
    goToAddEvent() {
      this.$router.push({
        name: 'eventAdd',
        query: {
          date: format(this.date, 'yyyy-MM-dd')
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.event-date-card {
  background-color: #FFFFFF;
  border-radius: 8px;
  padding: 16px;
  margin-bottom: 16px;

  &__inner {
    display: flex;
    justify-content: space-between;
    align-items: center;
  }

  &.today {
    background-color: lighten($l-blue, 50%)
  }

  &__date {
    font-size: 14px;
    font-weight: 700;

    &.--saturday {
      color: $l-blue;
    }
    &.--sunday, &.--holiday {
      color: red;
    }
  }
}

.event__add-btn {
  width: 36px;
  height: 36px;
  display: flex;
  justify-content: center;
  align-items: center;
  box-shadow: 1px 2px 6px $grey05;
  background-color: $white;
}

.event__add-icon {
  color: $l-blue;
}
</style>